import React from 'react';
import { Shield } from 'lucide-react';
import { Section } from './Shared';
export const Guarantee = () => <Section className="max-w-3xl" data-id="element-89">
    <div className="glass-panel p-8 md:p-12 rounded-3xl text-center border-brand-gold/40 bg-white/85 shadow-sm" data-id="element-90">
      <Shield className="w-14 h-14 md:w-16 md:h-16 text-brand-goldDark mx-auto mb-6" data-id="element-91" />
      <h2 className="text-xl md:text-3xl font-display font-bold mb-4 text-brand-violetDark" data-id="element-92">
        🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
      </h2>
      <p className="text-brand-text/80 mb-4 text-base md:text-lg" data-id="element-93">
        Abrís los tomos. Aplicás los protocolos. Los usás en tu práctica.
      </p>
      <p className="text-brand-text/80 mb-6 text-base md:text-lg" data-id="element-94">
        Si en 7 días no es lo que esperabas: devolución del 100% sin
        formularios, sin drama.
      </p>
      <p className="font-medium text-brand-violet text-sm md:text-base" data-id="element-95">
        Tasa de devoluciones: menos del 1%.
      </p>
    </div>
  </Section>;
export const Footer = () => <footer className="bg-brand-violetDark text-white/85 py-12 border-t border-brand-gold/20" data-id="element-96">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-97">
      <div className="mb-8" data-id="element-98">
        <h3 className="font-display font-bold text-2xl text-brand-goldLight mb-2" data-id="element-99">
          🌿 LUMEN AKASHA™
        </h3>
        <p className="text-white/75" data-id="element-100">
          El sistema profesional N°1 para terapeutas en Constelaciones
          Familiares en Argentina.
        </p>
        <p className="text-white/75 mt-2" data-id="element-101">
          Porque acompañar procesos sistémicos con excelencia no debería
          costarte la seguridad de tu práctica.
        </p>
      </div>

      <div className="flex flex-col md:flex-row justify-center items-center space-y-4 md:space-y-0 md:space-x-8 mb-12 text-sm" data-id="element-102">
        <a href="mailto:soportelumenakasha@gmail.com" className="hover:text-brand-goldLight transition-colors" data-id="element-103">
          📧 soportelumenakasha@gmail.com
        </a>
        <a href="https://instagram.com/lumen.akasha" className="hover:text-brand-goldLight transition-colors" data-id="element-104">
          📲 @lumen.akasha
        </a>
        <a href="https://www.lumenakasha.com" className="hover:text-brand-goldLight transition-colors" data-id="element-105">
          🌐 www.lumenakasha.com
        </a>
      </div>

      <div className="text-xs text-white/50 space-y-2" data-id="element-106">
        <p data-id="element-107">
          © Lumen Akasha™ 2024 — Todos los derechos reservados. Prohibida la
          reproducción y redistribución sin autorización expresa.
        </p>
        <p data-id="element-108">Ley 25.326 — Protección de Datos Personales — República Argentina</p>
      </div>

      <div className="mt-8" data-id="element-109">
        <p className="text-sm font-serif italic text-brand-goldLight/70" data-id="element-110">
          🌿 "El terapeuta que tiene un sistema, trabaja con confianza. El que
          trabaja con confianza, genera resultados. El que genera resultados,
          crece."
        </p>
      </div>
    </div>
  </footer>;